<app-loading [(ativo)]="ativo" text="Estamos carregando suas informações. Vale a pena aguardar!"></app-loading>

<div *ngIf="executar" class="container" [hidden]="ativo">
  <h1>Acompanhe suas solicitações</h1>
  <nav>
    <div class="nav tabs" id="nav-tab-historico" role="tablist">

      <a class="nav-item nav-link active" [ngClass]="{'active': itemDeclaracao == true}"
        (click)="menuAtivo('declaracao')" [routerLink]="['./']" fragment="nav-declaracao" id="nav-declaracao-tab"
        data-toggle="tab" href="#nav-declaracao" role="tab" aria-controls="nav-declaracao"
        aria-selected="true">Solicitações de Declaração Completa</a>

      <a class="nav-item nav-link ofertas" [ngClass]="{'active': itemOfertas == true}" (click)="menuAtivo('ofertas')"
        [routerLink]="['./']" fragment="nav-ofertas" id="nav-ofertas-tab" data-toggle="tab" href="#nav-ofertas"
        role="tab" aria-controls="nav-ofertas" aria-selected="false">Solicitações de Gerenciamento de dados pessoais
        para Direcionamento de Ofertas</a>
    </div>
  </nav>
  <div class="tab-content" id="nav-historico">
    <app-declaracao-completa [histDeclaracaoComp]="historicoSolicitacao.analyticals" *ngIf="itemDeclaracao"
      class="tab-pane fade show active" id="nav-declaracao" role="tabpanel" aria-labelledby="nav-declaracao-tab">
    </app-declaracao-completa>
    <app-direcionamento-ofertas [histDirectOfertas]="historicoSolicitacao.consent" *ngIf="itemOfertas"
      class="tab-pane fade show active" id="nav-ofertas" role="tabpanel" aria-labelledby="nav-ofertas-tab">
    </app-direcionamento-ofertas>
  </div>
</div>




